import { Box, CircularProgress, Grid } from '@material-ui/core'
import { CircularProgressProps } from '@material-ui/core/CircularProgress'
import React from 'react'

const LoadingSpinner = (props: CircularProgressProps) => {
  return (
    <Grid container alignItems="center" justify="center">
      <Box p={1}>
        <CircularProgress {...props} />
      </Box>
    </Grid>
  )
}
export default LoadingSpinner
